export const enum VoiceEvent {
  ARRIVE = 2000,
  ANSWER = 2001,
  END = 2010,
}
